module.exports = __webpack_public_path__ + "img/smartphone.5c375282.svg";